import {
  GET_PUBLIC_TEMPLATES_REQUEST,
  DELETE_PUBLIC_TEMPLATE_REQUEST,
  CLEAR_PUBLIC_TEMPLATES_STATE,
  CREATE_PUBLIC_TEMPLATE_REQUEST,
  INIT_REDUCER,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  UPDATE_PUBLIC_TEMPLATE_REQUEST,
  COPY_PUBLIC_TEMPLATE_REQUEST,
  CREATE_ERRORS,
  CLEAR_PUBLIC_TEMPLATE_COPIED,
} from './types';

const getPublicTemplates = (payload) => ({
  type: GET_PUBLIC_TEMPLATES_REQUEST,
  payload,
});

const createPublicTemplate = (payload) => ({
  type: CREATE_PUBLIC_TEMPLATE_REQUEST,
  payload,
});

const updatePublicTemplate = (payload) => ({
  type: UPDATE_PUBLIC_TEMPLATE_REQUEST,
  payload,
});

const deletePublicTemplate = (payload) => ({
  type: DELETE_PUBLIC_TEMPLATE_REQUEST,
  payload,
});

const copyPublicTemplate = (payload) => ({
  type: COPY_PUBLIC_TEMPLATE_REQUEST,
  payload,
});

const clearPublicTemplatesState = () => ({
  type: CLEAR_PUBLIC_TEMPLATES_STATE,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const clearErrorsProfile = () => ({
  type: CLEAR_ERRORS_PROFILE,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

const clearCopied = () => ({
  type: CLEAR_PUBLIC_TEMPLATE_COPIED,
});

export {
  getPublicTemplates,
  createPublicTemplate,
  updatePublicTemplate,
  deletePublicTemplate,
  clearPublicTemplatesState,
  initReducer,
  clearErrors,
  clearErrorsProfile,
  createErrors,
  copyPublicTemplate,
  clearCopied,
};
